import { render } from "./ContactSuccess.vue?vue&type=template&id=16795bcb&scoped=true"
import script from "./ContactSuccess.vue?vue&type=script&lang=js"
export * from "./ContactSuccess.vue?vue&type=script&lang=js"

import "./ContactSuccess.vue?vue&type=style&index=0&id=16795bcb&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16795bcb"]])

export default __exports__